var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoTopBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 52,
    viewBox: "0 0 932 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0H917C925.284 0 932 6.71573 932 15V51.9126H0V15Z",
    fill: "#F1F3F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.0159 33.9428C67.4028 33.9428 70.9591 30.3672 70.9591 25.9563C70.9591 21.5455 67.4028 17.9697 63.0159 17.9697C58.629 17.9697 55.0727 21.5455 55.0727 25.9563C55.0727 30.3672 58.629 33.9428 63.0159 33.9428Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M94.7886 33.9428C99.1755 33.9428 102.732 30.3672 102.732 25.9563C102.732 21.5455 99.1755 17.9697 94.7886 17.9697C90.4017 17.9697 86.8454 21.5455 86.8454 25.9563C86.8454 30.3672 90.4017 33.9428 94.7886 33.9428Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M32.3023 33.9428C36.6892 33.9428 40.2455 30.3672 40.2455 25.9563C40.2455 21.5455 36.6892 17.9697 32.3023 17.9697C27.9154 17.9697 24.3591 21.5455 24.3591 25.9563C24.3591 30.3672 27.9154 33.9428 32.3023 33.9428Z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M880.105 13.9766H150.391V38.9346H880.105V13.9766Z",
    fill: "#2F2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 932,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTopBar);
export default __webpack_public_path__ + "static/media/VideoTopBar.c122e2a7c3f31d8e6da7984b222edb53.svg";
export { ForwardRef as ReactComponent };